import React from 'react';

export default function CheckIcon(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M6.96271 12.5677L3.66146 9.26646L2.53729 10.3827L6.96271 14.8081L16.4627 5.30812L15.3465 4.19187L6.96271 12.5677Z"
                fill="black"
            />
        </svg>
    );
}
